import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { to: '/garages', label: 'Garages' },
  { to: '/venues', label: 'Venues' },
  { to: '/events', label: 'Events' },
  { to: '/teams', label: 'Teams' },
  { to: '/cities', label: 'Cities' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-gray-100 bg-white/95 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="ParkingRank home">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl border-2 border-gray-900">
              <ArrowUpRight className="h-5 w-5 text-[#17A24A]" strokeWidth={2.5} />
            </span>
            <span className="text-lg font-bold tracking-tight text-gray-900">ParkingRank</span>
          </Link>

          <nav className="hidden md:flex items-center gap-7" aria-label="Primary navigation">
            {NAV_LINKS.map((link) => {
              const active = pathname === link.to || pathname.startsWith(`${link.to}/`);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm font-medium transition-colors ${active ? 'text-gray-950' : 'text-gray-600 hover:text-gray-950'}`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden md:flex items-center gap-4">
            <Link to="/methodology" className="text-sm font-medium text-gray-600 hover:text-gray-950 transition-colors">
              How scoring works
            </Link>
            <Link
              to="/garages"
              className="inline-flex items-center gap-1.5 rounded-full bg-[#17A24A] px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-90"
            >
              Find a garage <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <button
            type="button"
            className="md:hidden p-2 text-gray-700"
            onClick={() => setMobileOpen((open) => !open)}
            aria-expanded={mobileOpen}
            aria-controls="mobile-navigation"
            aria-label="Toggle navigation"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav id="mobile-navigation" className="md:hidden border-t border-gray-100 bg-white px-4 py-4" aria-label="Mobile navigation">
          <div className="space-y-1">
            {NAV_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className="block rounded-lg px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                {link.label}
              </Link>
            ))}
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2 border-t border-gray-100 pt-3">
            <Link to="/methodology" className="rounded-full border border-gray-200 px-3 py-2 text-center text-sm font-semibold text-gray-700">
              How it works
            </Link>
            <Link to="/garages" className="rounded-full bg-[#17A24A] px-3 py-2 text-center text-sm font-semibold text-white">
              Find a garage
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
